import {Component, forwardRef, SimpleChanges, Input, ChangeDetectorRef, Injector} from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormControl, Validators } from '@angular/forms';
import { BarcodesVerificationModel, Enum_SoudotecBarcodesVerificationStatus, Enum_SoudotecBarcodesVerificationModeScan } from '../barcodes-verification.model';
import { AbstractWorkflowFormComponent } from '../../../@core/abstract-workflow-form-component';
import { WorkflowComponentsService } from '../../../workflow-components.service';
import { BarcodesVerificationService } from '../barcodes-verification.service';
import { TYPE_DEFAULT_VALUE, Model_WorkflowComponent } from 'src/app/app.models';
import { DynamicInputModelConfig, DynamicInputModel } from '@ng-dynamic-forms/core';
import { Model_SoudotecDocument } from '../../soudotec.models';

enum Command_View {
  IDLE = 0,
  COMMAND_LOADING = 1,
  COMMAND_LOADED = 2,
  COMMAND_LOADING_ERROR = 3
}

@Component({
    selector: 'abw-barcodes-verification-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => BarcodesVerificationFormComponent),
        multi: true
      },
      {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => BarcodesVerificationFormComponent),
        multi: true
      }
    ],
    templateUrl: './barcodes-verification-form.component.html',
    styleUrls: ['./barcodes-verification-form.component.scss']
})
export class BarcodesVerificationFormComponent extends AbstractWorkflowFormComponent<BarcodesVerificationModel, any> {

  @Input() doDomaine: number;
  @Input() doType: number;
  @Input() modeScan: Enum_SoudotecBarcodesVerificationModeScan;
  Enum_SoudotecBarcodesVerificationModeScan = Enum_SoudotecBarcodesVerificationModeScan;
  Command_View = Command_View;
  viewMode = Command_View.IDLE;
  doPiece: string = null;
  articles: any[] = [];
  document: any = {};
  errorText: string = null;
  Enum_SoudotecBarcodesVerificationStatus = Enum_SoudotecBarcodesVerificationStatus;

  constructor(
    private _barcodesVerificationService: BarcodesVerificationService,
    _workflowComponentsService: WorkflowComponentsService,
    _cdf: ChangeDetectorRef,
    _injector: Injector
  ) {
      super(_workflowComponentsService, _cdf, _injector);
  }

  ngOnInit() {
    super.ngOnInit();

    let doPiece = '';
    const typeDefaultNumPiece = this.model.additional['TYPE_DEFAULT_NUM_PIECE'];
    if (typeDefaultNumPiece == TYPE_DEFAULT_VALUE.CONSTANT) {
      doPiece = this.model.additional['DEFAULT_NUM_PIECE'];
    } else if (typeDefaultNumPiece == TYPE_DEFAULT_VALUE.WORKFLOW_FIELD) {
      const componentId = this.model.additional['DEFAULT_NUM_PIECE_WORKFLOW_COMPONENT_ID'];
      const componentProperty = this.model.additional['DEFAULT_NUM_PIECE_WORKFLOW_COMPONENT_PROPERTY'];
      const workflowValues = this._workflowComponentsService.context;
      const workflowComponent = (this.model as any).additional as Model_WorkflowComponent;
      let formGroupId = workflowComponent.FORM_ID || '_FORM_';
      const targetComponent: any = workflowValues.formModels[formGroupId].find(component => component.id == componentId);
      if (!!targetComponent) {
        if (!!componentProperty && !!targetComponent.additional && !!targetComponent.additional.NUM_DATASOURCE && !!targetComponent.datas) {
          const selectedData = targetComponent.datas.find(data => data[targetComponent.valueField] == targetComponent.value);
          if (!!selectedData && !!selectedData[componentProperty]) {
            doPiece = selectedData[componentProperty];
          }
        } else {
          doPiece = targetComponent.value;
        }
      }
    }
    this.doPiece = doPiece;

    if (!!this.doPiece) {
      this._doGetSageDocumentAction();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  onScanned(rowIndex: number, scannedValue: any) {
    let statut = Enum_SoudotecBarcodesVerificationStatus.CORRESPONDANCE_OK;
    const article = this.articles[rowIndex];
    if (article.AR_CodeBarre === scannedValue) {
        statut = Enum_SoudotecBarcodesVerificationStatus.CORRESPONDANCE_OK;
    } else {
        statut = Enum_SoudotecBarcodesVerificationStatus.CORRESPONDANCE_NON_OK;
    }
    this.articles[rowIndex].STATUS = statut;
    this.articles[rowIndex].SCAN_CODE = scannedValue;

    this._evaluateSoudotecDocument();
  }

  private _evaluateSoudotecDocument() {
    const document: Model_SoudotecDocument = {
      cbMarq: this.document.cbMarq,
      Do_Domaine: this.doDomaine,
      DO_Type: this.doType,
      DO_Piece: this.doPiece,
      DO_Ref: this.document.DO_Ref,
      DO_Tiers: this.document.DO_Tiers,
      DO_Date: this.document.DO_Date,
      DO_TotalHTNet: this.document.DO_TotalHTNet,
      DO_TotalTTC: this.document.DO_TotalTTC,
      LIGNES: this.articles.map(ligne => ({ 
        cbMarq: ligne.cbMarq, 
        AR_Ref: ligne.AR_Ref, 
        AR_Design: ligne.DL_Design, 
        AR_CodeBarre: ligne.AR_CodeBarre, 
        DL_Qte: ligne.DL_Qte,
        ABW_CodeScanned: ligne.SCAN_CODE,
        ABW_StatutCode: ligne.STATUS
      }))
    };
    this.onValueChanged(document);
  }

  private _doGetSageDocumentAction() {
    return new Promise<void>((resolve, reject) => {
      this.viewMode = Command_View.COMMAND_LOADING;
      this._barcodesVerificationService.doGetSageDocumentAction(this.doDomaine, this.doType, this.doPiece)
      .subscribe((_document: any) => {
        try {
          this.document = _document;
          this.articles = _document.LIGNES.map(l => ({ 
            cbMarq: l.cbMarq, 
            AR_CodeBarre: l.AR_CodeBarre, 
            AR_Ref: l.AR_Ref, 
            DL_Design: l.DL_Design, 
            DL_Qte: l.DL_Qte, 
            SCAN_CODE: new FormControl(null, Validators.required),
            STATUS: !!l.AR_CodeBarre ? Enum_SoudotecBarcodesVerificationStatus.CORRESPONDANCE_NON_OK : Enum_SoudotecBarcodesVerificationStatus.AUCUNE_CORRESPONDANCE 
          }));
          this.viewMode = Command_View.COMMAND_LOADED;
          this.onValueChanged(null);
        } catch(e) {
          this.errorText = 'Une erreur est survenue lors de l\'affichage du document. Assurez vous que les paramètres soient correctement synchronisés. (Contactez un administrateur).';
          this.viewMode = Command_View.COMMAND_LOADING_ERROR;
          console.log(e);
        }
        this._cdf.detectChanges();
        resolve();
      }, err => {
        this.errorText = 'Une erreur est survenue lors du chargement de la commande. Veuillez réessayer plus tard.';
        this.viewMode = Command_View.COMMAND_LOADING_ERROR;
        console.log(err);
        reject(err);
      });
    });
  }
}